import { style } from '@do/walrus';
import React from 'react';
import communityBg from './assets/backgrounds/Registration_Community.gif';
import marketplaceBg from './assets/backgrounds/Registration_Marketplace.jpg';
import oauthBg from './assets/backgrounds/Registration_Oauth.gif';
import teamBg from './assets/backgrounds/Registration_Team.gif';

import newBrandBg from './assets/backgrounds/new-brand-bg.png';
import ghStudentBg from './assets/partners/github/github_student_bg.png';
import ghStudentLogo from './assets/partners/github/github_student_logo.png';
import glitchBg from './assets/partners/glitch/glitch_bg.png';
import glitchLogo from './assets/partners/glitch/glitch_logo.png';
import lfBg from './assets/partners/lf/lf_bg.png';
import lfLogo from './assets/partners/lf/lf_logo.png';

import CoralBackground from './components/CoralBackground';
import {
  ButtonVariations,
  VariationTemplates,
  Variant
} from './interfaces/variant';

interface VariantMap {
  [id: string]: Variant;
}

const defaults = {
  type: 'default',
  background: <CoralBackground />,
  title: 'Create your account',
  subtitle:
    'And start spending more time on your projects and less time managing your infrastructure.'
};

const registrationVariants: VariantMap = {
  primary: defaults,

  marketplace: Object.assign({}, defaults, {
    type: 'marketplace',
    background: {
      image: marketplaceBg,
      horizontalPosition: 'right'
    },
    title: 'Sign up & deploy – in minutes!',
    subtitle: 'Marketplace solutions let you deploy with a single click!',
    metadata: {
      title:
        'Your {{registrationFormData.marketplace_app.name}} app is a few steps away',
      description: 'You need to create an account on DigitalOcean'
    }
  }),

  community: Object.assign({}, defaults, {
    type: 'community',
    background: {
      image: communityBg
    },
    title: 'All aboard! Join the DigitalOcean Community',
    subtitle: 'Our Community brings developers together. Join us, would you?'
  }),

  oauth_app: Object.assign({}, defaults, {
    type: 'oauth',
    background: {
      image: oauthBg
    },
    title: 'Authorization needed',
    subtitle:
      'In order to use {{registrationFormData.oauth_app.name}}, you’ll need to create a DigitalOcean account.'
  }),

  team: Object.assign({}, defaults, {
    type: 'team',
    background: {
      image: teamBg,
      horizontalPosition: 'center',
      verticalPosition: 'center'
    },
    title: 'Join your team on DigitalOcean!',
    subtitle:
      '{{registrationFormData.team}} has invited you to join them. Sign up and start making waves with your team today!'
  }),

  glitchPartner: Object.assign({}, defaults, {
    version: VariationTemplates.NEW_BRAND,
    splash: {
      type: 'glitchPartner',
      version: VariationTemplates.SPLIT,
      background: {
        image: glitchBg
      },
      image: glitchLogo,
      title: 'Deploy your project to DigitalOcean',
      subtitle:
        'Easily deploy Glitch projects on DigitalOcean’s App Platform using your project’s environment variable configuration.'
      /*button: {
        variation: ButtonVariations.PRIMARY,
        text: 'Learn more',
        url:
          'https://www.digitalocean.com/blog/new-droplet-console-ssh-support/'
      }*/
    }
  }),

  lfPartner: Object.assign({}, defaults, {
    version: VariationTemplates.NEW_BRAND,
    splash: {
      type: 'lfPartner',
      version: VariationTemplates.SPLIT,
      background: {
        image: lfBg
      },
      image: lfLogo,
      title: 'Open Source Skills Development',
      subtitle:
        "Linux Foundation Training & Certification offers training courses to build knowledge and skills, and certification exams to test and demonstrate learnings and capabilities, around the world's most important open source technologies, including Linux, Kubernetes, Node.js, Hyperledger, RISC-V, and much more.",
      textColor: style.colors.grey.darkest
    }
  }),
  newBrand: Object.assign({}, defaults, {
    type: 'newBrand',
    version: VariationTemplates.NEW_BRAND,
    background: {
      image: newBrandBg
    },
    subtitle:
      'Start spending more time on your projects and less time managing your infrastructure.'
  }),
  githubStudentPack: Object.assign({}, defaults, {
    type: 'githubStudentPack',
    version: VariationTemplates.NEW_BRAND,
    title: 'Sign up for DigitalOcean',
    splash: {
      type: 'ghPartner',
      version: VariationTemplates.SPLIT,
      background: {
        image: ghStudentBg
      },
      image: ghStudentLogo,
      title: 'GitHub Student Developer Pack',
      subtitle:
        /* eslint-disable-next-line @do/no-hardcoded-prices */
        'As a part of GitHub student developer pack, you will receive $100 in credit that are valid for 1 year. Once you sign up you will be prompet to verify your GitHub account',
      textColor: style.colors.grey.darkest,
      button: {
        variation: ButtonVariations.SECONDARY,
        text: 'Learn more',
        fullWidth: true,
        url:
          'https://www.digitalocean.com/blog/new-droplet-console-ssh-support/'
      }
    },
    background: {
      color: '#eff2fb'
    },
    subtitle:
      'You will need to create an account by authenticating your GitHub account to claim your credits'
  })
};

export default registrationVariants;

export const RefcodeVariantMapping: VariantMap = {
  marketrefcode: registrationVariants.marketplace,
  '58a925265b7b': registrationVariants.glitchPartner,
  '3b1eb93990e5': registrationVariants.lfPartner,
  newBrand: registrationVariants.newBrand
};
